'use strict';

var pick$1 = require('../../../../_virtual/pick.js_commonjs-exports.js');

pick$1.__exports.__esModule = true;
pick$1.__exports.default = pick;
// source taken from https://github.com/rackt/redux/blob/master/src/utils/pick.js

function pick(obj, fn) {
  return Object.keys(obj).reduce(function (result, key) {
    if (fn(obj[key])) {
      result[key] = obj[key]; // eslint-disable-line
    }
    return result;
  }, {});
}
